import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.dp.profiling_dashboard"))),
      ]),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _vm.isLoading
            ? _c("base-loading")
            : _c(
                VRow,
                [
                  _c(VCol, { staticStyle: { "min-height": "650px" } }, [
                    _c("iframe", {
                      staticStyle: { border: "0" },
                      attrs: {
                        frameborder: "0",
                        allowfullscreen: "",
                        width: "100%",
                        height: "100%",
                        src: _vm.url,
                      },
                    }),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }